/**
 * Damos formato al timestamp. Si "full" es igual a true: en caso de que la fecha caiga en el día actual solo mostraremos la hora
 *
 * @param {*} timestamp
 * @param {*} full
 * @returns
 */
export default function timestampToDate(timestamp, full, pretty) {
    let dateReturn = null;
    if (timestamp) {

        let dateNow = new Date();
        let yNow = dateNow.getFullYear();
        let mNow = dateNow.getMonth() + 1;
        let dNow = dateNow.getDate();

        let date = new Date(timestamp * 1000);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();

        if (mi < 10) {
            mi = `0${mi}`;
        }
        if (m < 10) {
            m = `0${m}`;
        }

        // Meses abreviados en español
        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const mesNombre = meses[parseInt(m, 10) - 1];
        if (full) {
            if (pretty) {
                let hours =  formatAMPM(h, mi);
                dateReturn = `${d} ${mesNombre} ${y} ${hours}`;
            } else {
                dateReturn = `${d} ${mesNombre} ${y} ${h}:${mi}`;
            }
        } else if (yNow === parseInt(y) && mNow === parseInt(m) && dNow === parseInt(d)) {
            if (pretty) {
                let hours =  formatAMPM(h, mi);
                dateReturn = `Hoy ${hours}`;
            } else {
                dateReturn = `Hoy ${h}:${mi}`;
            }
        } else {
            if (pretty) {
                let hours =  formatAMPM(h, mi);
                dateReturn = `${d} ${mesNombre}, ${y} ${hours} h`;
            } else {
                dateReturn = `${d} ${mesNombre}, ${y}`;
            }
        }
    }

    return dateReturn;
}

function formatAMPM(hours, minutes) {
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12
    minutes = minutes < 10 ? '0'+minutes : minutes
    return `${hours}:${minutes} ${ampm}`
}
